import { Steps } from 'antd';
import { STUDIO_STEPS } from '../studioConstants';

// ─────────────────────────────────────────────────────────────────
// Product Creation Studio — left-side vertical stepper.
//
// AntD `Steps` rendered vertically with a one-line subtitle per step.
// Clicking any step jumps directly to it; the parent owns the active
// index. We don't enforce "must complete previous step" — the wizard
// lets the user move freely so they can correct typos without
// fighting validation, and a final validate-on-save runs at Step 7.
// ─────────────────────────────────────────────────────────────────

export default function ProductStudioStepper({ currentIndex, onJump, sectionStatusMap }) {
  return (
    <div className="erp-studio-stepper" aria-label="Product creation steps">
      <Steps
        direction="vertical"
        current={currentIndex}
        size="small"
        items={STUDIO_STEPS.map((step, idx) => {
          const isCurrent  = idx === currentIndex;
          const isComplete = idx < currentIndex;
          const sectionStatus = sectionStatusMap && sectionStatusMap[step.key];
          return {
            title: (
              <button
                type="button"
                className="erp-step-jump"
                onClick={() => onJump(idx)}
                aria-current={isCurrent ? 'step' : undefined}
              >
                {step.title}
              </button>
            ),
            description: (
              <span>
                {step.subtitle}
                {sectionStatus ? (
                  <>
                    {' '}<span style={{ color: '#64748B' }}>· {sectionStatus}</span>
                  </>
                ) : null}
              </span>
            ),
            status: isCurrent ? 'process' : (isComplete ? 'finish' : 'wait')
          };
        })}
      />
    </div>
  );
}
